import PrintForm from "./view/Print/PrintForm";
import './assets/addPrinter.scss'
import PrinterList from "./view/Print/DiscountCodsList";
import TestLocalPrinter from "./view/Print/TestLocalPrinter";

export default function Printer() {
    return (
        <section className={"print-container"}>
            <section>
                <PrintForm/>
                <PrinterList/>
            </section>
            <TestLocalPrinter/>
        </section>
    );
}